export const SUPPORT_VOTED_TOPICS = 'support-voted-topics';
